<template>
  <div>
    <a-alert
      v-if="nomenclature != null"
      type="info" showIcon>
      <div slot="message">
        <div v-html="nomenclature"></div>
      </div>
    </a-alert>
    <br/>
    <a-spin :spinning="loading">
      <a-layout>
        <a-layout-content style="background: white;">
          <div id="workArea" :gutter="[16,16]">
            <analytics-chart-component v-for="component in setup.componentes"
                                       :options.sync="component.options"
                                       :height="setup.chartHeight"
                                       :width="setup.chartWidth"
                                       :idx="component.idx"
                                       :key="component.idx"></analytics-chart-component>
          </div>
        </a-layout-content>
      </a-layout>
    </a-spin>

    <a-card>
      <a-row :gutter="[1,1]" :md="12" :xs="24">
        <a-form-model :model="filterParams" v-bind="fiOptions" ref="filterForm">
          <a-col v-bind="colOptionsHours">
            <a-form-model-item :rules="[{ required: true, message: 'Valor requerido' }]"  v-bind="fiOptions" :label="$t('Año')" style="width: 100%" prop="anio" has-feedback>
              <a-select v-model="filterParams.anio" style="width: 100%">
                <a-select-option v-for="year_ in years" :key="year_" style="width: 100%">
                  {{ year_ }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col v-bind="colOptionsHours">
            <a-form-model-item :label="$t('Sede')">
              <form-model-dropdown style="width: 100%"
                                   v-model="filterParams.dataset"
                                   :params="{h_lookup_type: 'INCIDENCIAS_NOVEDADES', use_code: true}"
                                   endpoint="hierarchy_lookup">
              </form-model-dropdown>
            </a-form-model-item>
          </a-col>
          <a-col v-bind="colOptionsHours">
            <a-button type="primary"
                      @click="filtrar()"
                      icon="search"
                      style="width: 90px; margin-right: 8px">
              Buscar
            </a-button>
          </a-col>
        </a-form-model>
      </a-row>
      <div style="margin-top: 8px"></div>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="Horas" key="2">
          <g-master :name="masterRecargo.endpoint"
                    :endpoint="masterRecargo.endpoint"
                    :actions="false"
                    :tableSetup="masterRecargo.tableSetup"
                    :parentData="parentData"
                    modalWidth="80%"
          >
          </g-master>
        </a-tab-pane>
      </a-tabs>
    </a-card>
    <a-card>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="Detalle de novedades" key="1">
          <a-alert
            v-if="nomenclature != null"
            type="info" showIcon>
            <div slot="message">
              <div v-html="nomenclature"></div>
            </div>
          </a-alert>
          <br/>
          <a-row :gutter="[1,1]" :md="12" :xs="24">
            <a-form-model :model="filterParamsDetalle" v-bind="fiOptions" ref="filterFormDetail">
              <a-col v-bind="colOptions">
                <a-form-model-item :label="$t('Sede')" :rules="[{ required: true, message: 'Valor requerido' }]" prop="id_h_att1">
                  <form-model-dropdown style="width: 100%"
                                       v-model="filterParamsDetalle.id_h_att1"
                                       :params="{h_lookup_type: 'ID_H_ATT1'}"
                                       endpoint="hierarchy_lookup">
                  </form-model-dropdown>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-model-item :label="$t('Seccion')">
                  <form-model-dropdown style="width: 100%"
                                       v-model="filterParamsDetalle.id_h_att2"
                                       :params="puestoParams"
                                       endpoint="hierarchy_lookup">
                  </form-model-dropdown>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-model-item prop="date_mark_ini" :label="$t('Rango')"
                                   :rules="[{ required: true, message: 'Valor requerido' }]">
                  <a-range-picker style="width: 100%" v-model="filterParamsDetalle.date_mark_ini"/>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-button type="primary"
                          @click="filtrarDetalle()"
                          icon="search"
                          style="width: 90px; margin-right: 8px">
                  Buscar
                </a-button>
              </a-col>
            </a-form-model>
          </a-row>
          <g-master :name="masterDetalleHoras.endpoint"
                    :endpoint="masterDetalleHoras.endpoint"
                    :actions="false"
                    :tableSetup="masterDetalleHoras.tableSetup"
                    :parentData="parentDataDetalle"
                    modalWidth="80%"
          >
          </g-master>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </div>
</template>
<script>
  import Sortable from 'sortablejs'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        filterParamsDetalle: {
          id_h_att1: null,
          id_h_att2: null,
          date_mark_ini: undefined
        },
        filterParams: {
          anio: null,
          dataset: null
        },
        datasetSelected: null,
        yearToSerach: null,
        grupo: null,
        puesto: null,
        date_mark_ini: undefined,
        yearToday: parseInt(moment().format('YYYY')),
        years: [],
        colOptions: {xs: 24, sm: 12},
        colOptionsHours: {xs: 24, sm: 8},
        fiOptions: {
          'label-col': {span: 4},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        setup: {
          componentes: [],
          chartHeight: 300,
          chartWidth: 500
        },
        presetId: null,
        presetSelected: null,
        savePresetVisible: false,
        presetInfo: {
          action: 'create', // edit
          publico: false,
          nombre: ''
        },
        loading: false,
        masterRecargo: {
          endpoint: 'novelty_store_query',
          tableSetup: {
            actions: false,
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Sede', dataIndex: 'seccion', sorter: true},
              {title: 'Novedad', dataIndex: 'novedad', sorter: true},
              {title: 'Enero', dataIndex: 'enero', sorter: true},
              {title: 'Febrero', dataIndex: 'febrero', sorter: true},
              {title: 'Marzo', dataIndex: 'marzo', sorter: true},
              {title: 'Abril', dataIndex: 'abril', sorter: true},
              {title: 'Mayo', dataIndex: 'mayo', sorter: true},
              {title: 'Junio', dataIndex: 'junio', sorter: true},
              {title: 'Julio', dataIndex: 'julio', sorter: true},
              {title: 'Agosto', dataIndex: 'agosto', sorter: true},
              {title: 'Septiembre', dataIndex: 'septiembre', sorter: true},
              {title: 'Octubre', dataIndex: 'octubre', sorter: true},
              {title: 'Noviembre', dataIndex: 'noviembre', sorter: true},
              {title: 'Diciembre', dataIndex: 'diciembre', sorter: true}
            ]
          }
        },
        nomenclature: null,
        masterDetalleHoras: {
          endpoint: 'novelty_query',
          tableSetup: {
            actions: false,
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Nombre', dataIndex: 'nombre', sorter: true},
              {title: 'Cargo', dataIndex: 'cargo', sorter: true},
              {title: this.$t('Seccion'), dataIndex: 'puesto', sorter: true},
              {title: 'IEG', dataIndex: 'ieg', sorter: true},
              {title: 'AT', dataIndex: 'at', sorter: true},
              {title: 'LM', dataIndex: 'lm', sorter: true},
              {title: 'CD', dataIndex: 'cd', sorter: true},
              {title: 'LLT', dataIndex: 'llt', sorter: true},
              {title: 'LNR', dataIndex: 'lnr', sorter: true},
              {title: 'LR', dataIndex: 'lr', sorter: true},
              {title: 'DF', dataIndex: 'df', sorter: true},
              {title: 'LP', dataIndex: 'lp', sorter: true},
              {title: 'V', dataIndex: 'v', sorter: true},
              {title: 'Total Novedades', dataIndex: 'totalnovedad', sorter: true}
            ]
          }
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil('analytics_presets')
      this.httpClient.getInstance().get('analytics_presets')
        .then(response => {
          const resultado = response.data.find(obj => obj.name === 'NOVEDADES')
          this.setup = JSON.parse(resultado.preset_setup)
        })
        .catch(error => {
        })
        .then(() => {
        })
      this.httpClient.getInstance().get('extra_time_nomenclature')
        .then(response => {
          this.nomenclature = response.data["MENSAJE_NOMENCLATURA_NOVEDADES"];
        })
        .catch(error => {
        })
        .then(() => {
        })
      this.yearsSelect()
      let el = document.getElementById('workArea')
      this.sortable = Sortable.create(el, {
        animation: 150,
        ghostClass: 'blue-background-class'
      })
    },
    computed: {
      parentData () {
        let finalFilter = {
          anio: this.yearToSerach
        }
        if (this.datasetSelected != null) {
          finalFilter = {
            anio: this.yearToSerach,
            dataset: this.datasetSelected
          }
        }
        return finalFilter
      },
      parentDataDetalle () {
        let finalFilter = {
          id_h_att1: this.grupo,
          date_mark_ini: this.date_mark_ini
        }
        if (this.puesto != null) {
          finalFilter = {
            id_h_att1: this.grupo,
            id_h_att2: this.puesto,
            date_mark_ini: this.date_mark_ini
          }
        }
        return finalFilter
      },
      puestoParams () {
        return {
          h_lookup_type: 'ID_H_ATT2',
          id_h_lookup_father: this.filterParamsDetalle.id_h_att1 ? this.filterParamsDetalle.id_h_att1 : -1
        }
      }
    },
    methods: {
      filtrar () {
        this.$refs.filterForm.validate(valid => {
          if (valid) {
            this.yearToSerach = this.filterParams.anio
            this.datasetSelected = this.filterParams.dataset
          }
        })
      },
      filtrarDetalle () {
        this.$refs.filterFormDetail.validate(valid => {
          if (valid) {
            this.grupo = this.filterParamsDetalle.id_h_att1
            this.puesto = this.filterParamsDetalle.id_h_att2
            this.date_mark_ini = this.filterParamsDetalle.date_mark_ini
          }
        })
      },
      yearsSelect () {
        for (let i = 2024; i <= (this.yearToday); i++) {
          this.years.push(i)
        }
      }
    }
  }
</script>
<style>
  .blue-background-class {
    background: rgba(0, 0, 255, 0.1);
  }
</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/RecargosYNovedades/Novedades.vue